import React, { useRef, useState, useEffect, Suspense } from 'react';
import { Canvas, useFrame, useLoader } from '@react-three/fiber';
import { OrbitControls, Stars, TextureLoader } from '@react-three/drei';
import * as THREE from 'three';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';

const Earth = () => {
  const earthRef = useRef();
  const [earthObject, setEarthObject] = useState(null);
  
  // Load texture
  const [earthTexture, setEarthTexture] = useState(null);
  
  useEffect(() => {
    // Load texture first
    const textureLoader = new THREE.TextureLoader();
    textureLoader.load('/earth/earth-texture.jpg', (texture) => {
      setEarthTexture(texture);
    });

    // Load materials first
    const mtlLoader = new MTLLoader();
    mtlLoader.load('/earth/earth.mtl', (materials) => {
      materials.preload();
      
      // Load the OBJ file using the materials
      const objLoader = new OBJLoader();
      objLoader.setMaterials(materials);
      objLoader.load(
        '/earth/earth.obj',
        (object) => {
          // If texture is loaded, apply it to the mesh
          if (earthTexture) {
            object.traverse((child) => {
              if (child instanceof THREE.Mesh) {
                child.material.map = earthTexture;
                child.material.needsUpdate = true;
              }
            });
          }
          setEarthObject(object);
        },
        undefined,
        (error) => console.error('Error loading Earth model:', error)
      );
    });
  }, [earthTexture]);

  useFrame(({ clock }) => {
    if (earthRef.current) {
      earthRef.current.rotation.y = clock.getElapsedTime() * 0.05; // Slow rotation
    }
  });

  return (
    <group ref={earthRef} position={[0, 0, 0]} scale={[0.7, 0.7, 0.7]}>
      {earthObject && <primitive object={earthObject} />}
    </group>
  );
};

const Globe3D = () => {
  return (
    <div className="w-full h-[300px] sm:h-[400px] lg:h-[500px] overflow-hidden">
      <Canvas
        camera={{
          position: [0, 0, window.innerWidth < 640 ? 4.5 : 3.5],
          fov: window.innerWidth < 640 ? 70 : 60,
        }}
      >
        <ambientLight intensity={0.5} />
        <pointLight position={[10, 10, 10]} intensity={1.5} />
        <Stars radius={300} depth={60} count={5000} factor={7} saturation={0} fade />
        <Suspense fallback={null}>
          <Earth />
        </Suspense>
        <OrbitControls
          enableZoom={false}
          enablePan={false}
          enableRotate={true}
          autoRotate={true}
          autoRotateSpeed={0.5}
          minPolarAngle={Math.PI / 2.5}
          maxPolarAngle={Math.PI / 1.5}
        />
      </Canvas>
    </div>
  );
};

export default Globe3D;